/**
 * Änderungsstand eines Formulars (Story 1.23, EXPERIENCE §4.3): Jedes Formular vergleicht seinen GANZEN Wert mit dem
 * Wert beim Öffnen (bzw. nach dem Neuaufbau nach Speichern/Rückgängig) – nie Feld für Feld, damit neue Felder von selbst
 * zählen. Struktureller Vergleich: einfache Objekte, Arrays, Zahlen/Texte/Wahrheitswerte/`null`, `Date` (nach Zeitpunkt),
 * `Set`/`Map` (nach Inhalt). Eine Eigenschaft mit `undefined` gilt wie eine fehlende.
 */
export function isDirty(initial: unknown, current: unknown): boolean {
  return !sameValue(initial, current);
}

function sameValue(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (a instanceof Date || b instanceof Date) return a instanceof Date && b instanceof Date && a.getTime() === b.getTime();
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
  if (Array.isArray(a) || Array.isArray(b)) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((x, i) => sameValue(x, b[i]));
  }
  if (a instanceof Set || b instanceof Set) {
    return a instanceof Set && b instanceof Set && a.size === b.size && [...a].every((x) => b.has(x));
  }
  if (a instanceof Map || b instanceof Map) {
    return a instanceof Map && b instanceof Map && a.size === b.size && [...a].every(([k, v]) => b.has(k) && sameValue(v, b.get(k)));
  }
  const ra = a as Record<string, unknown>;
  const rb = b as Record<string, unknown>;
  const keys = new Set([...Object.keys(ra), ...Object.keys(rb)]);
  for (const k of keys) if (!sameValue(ra[k], rb[k])) return false;
  return true;
}
